import React from 'react';
import { useAccessControl } from '../contexts/AccessControlContext';

/**
 * FeatureGuard component that protects features based on database-driven permissions
 * @param {string} featureName - The name of the feature to check access for (e.g., 'SaveLoad', 'tourPlanning')
 * @param {string} requiredAccess - The required access level ('hidden', 'view_only', 'edit', 'full')
 * @param {ReactNode} children - The content to render if access is granted
 * @param {ReactNode} fallback - The content to render if access is denied (optional)
 */
const FeatureGuard = ({ featureName, requiredAccess, children, fallback = null }) => {
  const { hasFieldAccess } = useAccessControl();
  
  if (hasFieldAccess(featureName, requiredAccess)) {
    return children;
  }
  
  return fallback;
};

export default FeatureGuard;